"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SMTPSettingEnum;
(function (SMTPSettingEnum) {
    SMTPSettingEnum[SMTPSettingEnum["none"] = 0] = "none";
    SMTPSettingEnum[SMTPSettingEnum["autoAlert"] = 1] = "autoAlert";
    SMTPSettingEnum[SMTPSettingEnum["custom"] = 2] = "custom";
})(SMTPSettingEnum = exports.SMTPSettingEnum || (exports.SMTPSettingEnum = {}));
